import React from 'react';

import { alertIcon } from '@justgiving/icons';
import SVG from '@justgiving/svg';
import cn from 'classnames';

import styles from './InlineError.scss';

type InlineErrorProps = {
  message: string | JSX.Element;
  className: string;
};

export const InlineError: React.FC<InlineErrorProps> = ({
  message,
  className,
}) => (
  <div className={cn(className, styles.inlineError)}>
    <div className={styles.icon}>
      <SVG className={styles.svg} markup={alertIcon} />
    </div>
    <div className={styles.message}>{message}</div>
  </div>
);
